import { useMutation } from 'react-query';

import { updateProjectSiteSpecificSpaces } from 'shared/api/projects/http';

const useMutateUpdateProjectSiteSpecificSpaces = (options = undefined) =>
  useMutation(({ id, siteSpecificSpaces }) => updateProjectSiteSpecificSpaces(id, siteSpecificSpaces), options);

export default useMutateUpdateProjectSiteSpecificSpaces;
